export default __webpack_public_path__ + "static/media/BlueVolume-dsk.e99030f5.png";